import * as Yup from "yup";

import {
  isBikeProductCategory,
  isClothesProductCategory,
} from "./valuablesUtils/valuablesConditions";

import { useTexts } from "Components/TextContext";
import { formatNumber } from "Formatting/index";
import { isWholeThousand } from "Utils/numberUtils";
import { ValuablesProductFormState } from ".";

export const COVERAGE_AMOUNT_GENERAL_MIN = 5_000;
export const COVERAGE_AMOUNT_GENERAL_MAX = 50_000;

export const COVERAGE_AMOUNT_BIKE_MIN = 10_000;
export const COVERAGE_AMOUNT_FUR_NATIONAL_DRESS_MAX = 100_000;

export const getCoverageAmountSchema = (
  getText: ReturnType<typeof useTexts>["getText"],
): Yup.ObjectSchema<Pick<ValuablesProductFormState, "coverage_amount">> =>
  Yup.object()
    .defined()
    .shape({
      coverage_amount: Yup.number()
        .required(getText("valuablesform.validation.coverage_amount-required"))
        .min(
          COVERAGE_AMOUNT_GENERAL_MIN,
          getText("valuablesform.validation.coverage_amount-lower_boundary", {
            variables: {
              valuables_coverage_amount_lower_boundary: formatNumber(
                String(COVERAGE_AMOUNT_GENERAL_MIN),
                false,
              ),
            },
          }),
        )
        .max(
          COVERAGE_AMOUNT_GENERAL_MAX,
          getText("valuablesform.validation.coverage_amount-upper_boundary", {
            variables: {
              valuables_coverage_amount_upper_boundary: formatNumber(
                String(COVERAGE_AMOUNT_GENERAL_MAX),
                false,
              ),
            },
          }),
        )
        .when("product", {
          is: isBikeProductCategory,
          then: (schema) =>
            schema.min(
              COVERAGE_AMOUNT_BIKE_MIN,
              getText(
                "valuablesform.validation.coverage_amount-lower_boundary",
                {
                  variables: {
                    valuables_coverage_amount_lower_boundary: formatNumber(
                      String(COVERAGE_AMOUNT_BIKE_MIN),
                      false,
                    ),
                  },
                },
              ),
            ),
        })
        .when("product", {
          is: isClothesProductCategory,
          then: (schema) =>
            schema.max(
              COVERAGE_AMOUNT_FUR_NATIONAL_DRESS_MAX,
              getText(
                "valuablesform.validation.coverage_amount-upper_boundary",
                {
                  variables: {
                    valuables_coverage_amount_upper_boundary: formatNumber(
                      String(COVERAGE_AMOUNT_FUR_NATIONAL_DRESS_MAX),
                      false,
                    ),
                  },
                },
              ),
            ),
        })
        .test({
          name: "is-whole-thousand",
          message: getText(
            "valuablesform.validation.coverage_amount-not_whole_thousand",
          ),
          test: isWholeThousand,
        }),
    });
